import { defer, type LoaderFunctionArgs } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getDetailInfo } from "./common/services";

export function billDetailsLoader({ request }: LoaderFunctionArgs) {
  const transactionId = new URL(request.url).searchParams.get("tradeId") || "";
  return defer({
    coreData: resolveLoaderResult(getDetailInfo({ transactionId })),
  });
}
